var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrigeratorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "408C7204-7FBE-432A-92A7-448F15102F43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-648.000000, -1537.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(531.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refrigerator-light",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,2.5 C25.2578125,2.5 27.5,4.7421875 27.5,7.5 L27.5,12.5 L22.5,12.5 L22.5,8.75 C22.5,8.0625 21.9375,7.5 21.25,7.5 C20.5625,7.5 20,8.0625 20,8.75 L20,12.5 L2.5,12.5 L2.5,7.5 C2.5,4.7421875 4.7421875,2.5 7.5,2.5 L22.5,2.5 Z M20,15 L20,28.75 C20,29.4375 20.5625,30 21.25,30 C21.9375,30 22.5,29.4375 22.5,28.75 L22.5,15 L27.5,15 L27.5,35 C27.5,36.3828125 26.3828125,37.5 25,37.5 L5,37.5 C3.6171875,37.5 2.5,36.3828125 2.5,35 L2.5,15 L20,15 Z M7.5,0 C3.359375,0 0,3.359375 0,7.5 L0,35 C0,37.7578125 2.2421875,40 5,40 L25,40 C27.7578125,40 30,37.7578125 30,35 L30,7.5 C30,3.359375 26.640625,0 22.5,0 L7.5,0 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigeratorLight);
export default __webpack_public_path__ + "static/media/refrigerator-light.cf10ef827ef290ae5a425140caf44b28.svg";
export { ForwardRef as ReactComponent };